export const POSSIBLE_APPLICANTS: Array<string> = [
  "Primary Applicant",
  "Secondary Applicant",
  "Third Applicant",
  "Fourth Applicant",
]
